"use client";

import { useEffect } from 'react';

// Declaration for the emerging window.navigator.modelContext API
declare global {
  interface Navigator {
    modelContext?: {
      registerTool: (tool: any, options: { signal: AbortSignal }) => void;
    };
  }
}

export default function WebMCPRegistry() {
  useEffect(() => {
    // Only run if the API exists
    if (typeof window === 'undefined' || !navigator.modelContext || typeof navigator.modelContext.registerTool !== 'function') {
      return;
    }

    const abortController = new AbortController();

    // Register read-only tools as recommended by the report
    try {
      navigator.modelContext.registerTool(
        {
          name: 'get_product_info',
          description: 'Get information about MarketBetter AI products and capabilities',
          inputSchema: {
            type: 'object',
            properties: {
              feature: {
                type: 'string',
                description: 'The specific feature to get info about (e.g., audiences, plays, chatbot)'
              }
            }
          },
          execute: async ({ feature }: any) => {
            return {
              content: [
                {
                  type: 'text',
                  text: `MarketBetter AI is a comprehensive B2B marketing automation platform. Feature requested: ${feature || 'general overview'}.`
                }
              ]
            };
          }
        },
        { signal: abortController.signal }
      );

      navigator.modelContext.registerTool(
        {
          name: 'search_blog_posts',
          description: 'Search for marketing insights and guides on the MarketBetter blog',
          inputSchema: {
            type: 'object',
            properties: {
              query: {
                type: 'string',
                description: 'Topic to search for'
              }
            },
            required: ['query']
          },
          execute: async ({ query }: any) => {
            return {
              content: [
                {
                  type: 'text',
                  text: `Search results for "${query}" currently unavailable in this read-only capability.`
                }
              ]
            };
          }
        },
        { signal: abortController.signal }
      );
    } catch (e) {
      console.warn('Failed to register WebMCP tools', e);
    }

    return () => {
      abortController.abort();
    };
  }, []);

  return null;
}
